import React from "react";
import { connect } from "react-redux";

//import BountyPromo from '../../organisms/BountyPromo'
import { fetchUser } from "../../../actions";

import Spinner from "../../atoms/Spinner";

import UserSearchField from "../../molecules/UserSearchField/index";
import AdminUserViewer from "../../organisms/AdminUserViewer/index";
import OrdersAll from "../../molecules/OrdersAll/container";
import { Paper, Typography } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import { Tab } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Admin extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      activeTab: 1
    };
  }
  componentDidMount() {
    this.props.dispatch(fetchUser());
  }
  handleTabChange = (event, activeTab) => {
    this.setState({ activeTab });
  };

  render() {
    const { error, loading, User } = this.props;

    if (error) {
      return <div>Error! {error.message}</div>;
    }

    if (loading || this.props.step < 1) {
      return (
        <div align="center">
          <Spinner />
        </div>
      );
    }
    if (User && User.AuthGroup && User.AuthGroup.indexOf("Admin") !== -1) {
      // TODO: make active check
      const { activeTab } = this.state;
      return (
        <div>
          <Paper>
            <Typography variant="h4">Admin Dashboard</Typography>
            <Tabs
              value={activeTab}
              onChange={this.handleTabChange}
              textColor="primary"
            >
              <Tab label="Search" />
              <Tab label="Orders" />
              {/* <Tab label="Statistics" /> */}
            </Tabs>
          </Paper>

          {activeTab === 0 && (
            <React.Fragment>
              <UserSearchField />
              <AdminUserViewer />
            </React.Fragment>
          )}
          {activeTab === 1 && <OrdersAll />}
          <ToastContainer />
        </div>
      );
    } else {
      return <div>No Permissions!</div>;
    }
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  User: state.User,
  loading: state.loading,
  error: state.errorLoading
});

export default connect(mapStateToProps)(Admin);
